import { render, staticRenderFns } from "./ManageGroup.vue?vue&type=template&id=e52ebd4c"
import script from "./ManageGroup.vue?vue&type=script&lang=js"
export * from "./ManageGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports